import useCredits from './useCredits';
import useFeatureFlag from './useFeatureFlag';
import { FEATURE_FLAGS } from '../constants/FeatureFlag';

export type UseIsFreemiumOnboardingUserResult = {
  isFreemium: boolean;
  isResolved: boolean;
};

export function useIsFreemiumOnboardingUser(): UseIsFreemiumOnboardingUserResult {
  const { isRestricted, isLoading: isLoadingCredits } = useCredits();
  const { isFeatureFlagEnable, flagResolved } = useFeatureFlag(
    FEATURE_FLAGS.RELEASE.NEW_ONBOARDING,
  );

  return {
    isFreemium: isFeatureFlagEnable && !isRestricted,
    isResolved: flagResolved && !isLoadingCredits,
  };
}
